export const downloadBlob = (blob, filename, type) => {
  const a = document.createElement('a');
  a.href = `data:${type};base64,${blob}`;
  a.download = filename;
  a.click();
};
